module.exports = __webpack_public_path__ + "img/spirituality.95a5ecb.svg";